/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Newpatient_Ongoingformfor3Inputs */

const en_newpatient_ongoingformfor3 = /** @type {(inputs: Newpatient_Ongoingformfor3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You have an ongoing form for ${i?.name}`)
};

const fr_newpatient_ongoingformfor3 = /** @type {(inputs: Newpatient_Ongoingformfor3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vous avez un formulaire en cours pour ${i?.name}`)
};

/**
* | output |
* | --- |
* | "You have an ongoing form for {name}" |
*
* @param {Newpatient_Ongoingformfor3Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const newpatient_ongoingformfor3 = /** @type {((inputs: Newpatient_Ongoingformfor3Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newpatient_Ongoingformfor3Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_newpatient_ongoingformfor3(inputs)
	return fr_newpatient_ongoingformfor3(inputs)
});
export { newpatient_ongoingformfor3 as "newPatient_ongoingFormFor" }